var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"row-start align-center g-10 color-text-base menu-item",attrs:{"href":_vm.link.route}},[_c('CFaIcon',{staticClass:"w-20",attrs:{"icon":_vm.faIcon}}),_vm._v(" "),_c('p',{staticClass:"text-big"},[_vm._v(_vm._s(_vm.link.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }